import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
// import refreshToken from './refresh-token' // descomentar também em App.vue:94 (store.commit...)

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    // refreshToken,
  },
  strict: process.env.DEV,
})
